import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { isPolicyAllowsBsi } from '../lib/policy';
export class ConfigStorage {
  constructor(getCommonConfig, getConsentPolicy) {
    this.getCommonConfig = getCommonConfig;
    this.getConsentPolicy = getConsentPolicy;
    _defineProperty(this, "bsi", null);
  }
  checkPolicyAndDestroyIfNeeded() {
    if (!isPolicyAllowsBsi(this.getPolicy())) {
      if (this.call('get', 'bsi')) {
        this.destroy();
      }
      return false;
    }
    return true;
  }
  call(method) {
    const config = this.getCommonConfig();
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    return config && typeof config[method] === 'function' && config[method](...args);
  }
  getPolicy() {
    const policy = this.call('get', 'consentPolicy');
    if (policy) {
      return {
        policy
      };
    }
    return typeof this.getConsentPolicy === 'function' ? this.getConsentPolicy() : null;
  }
  get() {
    if (!this.checkPolicyAndDestroyIfNeeded()) {
      return null;
    }
    return this.call('get', 'bsi') || null;
  }
  set(bsi) {
    if (!this.checkPolicyAndDestroyIfNeeded()) {
      return null;
    }
    if (bsi !== this.call('get', 'bsi')) {
      this.bsi = bsi;
      this.call('set', 'bsi', bsi);
    }
    return bsi;
  }
  subscribe(handler) {
    this.call('subscribe', () => {
      const bsi = this.call('get', 'bsi');
      if (bsi !== this.bsi) {
        this.bsi = bsi;
        handler(bsi);
      }
    });
    return this;
  }
  destroy() {
    this.bsi = null;
    this.call('set', 'bsi', null);
  }
}
//# sourceMappingURL=config-storage.js.map